import "./functions/anchor-scroll";
import "./functions/slide-block";
import "./functions/to-top";

import "../../blocks/header/header";
import "../../blocks/form/scripts";
import "../../constructor-blocks/reviews/scripts";
import "../../constructor-blocks/offers/offers";
import "../../constructor-blocks/offers-slider/scripts";
